import React, { useState, useEffect } from 'react';
import { IoChevronBackCircleOutline } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { Card, Input, Form, Row, Col, Button, notification, Select } from 'antd';
import { MdAddCircleOutline } from "react-icons/md";
import {Link} from 'react-router-dom'
import { connect } from 'react-redux';
import {createSubscriptionRequest} from '../store/action/admin/SubscriptionAction';


const SubscriptionMaster = ({ createSubscription, subscriptionState={} }) => {
  const [form] = Form.useForm();
  const [listItems, setListItems] = useState([]); // To store the list of plans
  const [inputValue, setInputValue] = useState(''); // To track the input value
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const { loading = false, response = null, error = null } = subscriptionState;

  useEffect(() => {
    console.log('Subscription State Updated:', { response, error }); // Debug state
    if(isSubmitting){
      if (response?.message) {
        notification.success({
            message: 'Success',
            description: response.message, // Use the API's success message
        });
        form.resetFields();
        setListItems([]); // Clear the extra plans list
        setIsSubmitting(false)
    }
        if (error) {
          notification.error({
            message: 'Error',
            description: error || 'Something went wrong!',
          });
          setIsSubmitting(false); // Reset the flag
        }
    }
}, [response, error,isSubmitting]);



  
  const handleAddPlan = () => {
    if (inputValue.trim() !== '') {
      // Add the input value to the list and reset the input field
      setListItems([...listItems, inputValue]);
      setInputValue('');
    } else {
      notification.warning({
        message: 'Validation Error',
        description: 'Please enter a valid plan name!',
      });
    }
  };

  const handleRemove = (index) => {
    const updatedItems = listItems.filter((_, i) => i !== index);
    setListItems(updatedItems);
  };
  const onFinish = (values) => {
    const textcontent = listItems.reduce((acc, item, index) => {
        acc[`description${index + 1}`] = item;
        return acc;
    }, {});

    // Create the final payload for the API
    const payload = {
        provinceId: 1, 
        country:1,
        currency:"INR",
        category: parseInt(values.selectDomain, 10),
        title: values.planname,
        monthAmount: values.planAmountMonthly,
        anualAmount: values.planAmountMonthly,
        taxAmount: values.taxAmountMonthly,
        creditpoints: values.leadCount,
        textcontent,
        // country: parseInt(values.selectcountry, 10),
        // currency: values.currencycode,
    };
    setIsSubmitting(true);
    // Dispatch the Redux action
    createSubscription(payload);
};

const handleReset = ()=>{
  form.resetFields();
  setListItems([]); 
}


  return (
    <div>
      <Card title="Subscription Master" bordered={false} style={{ width: '100%' }}
      extra={<Link to='/admin/subscription-master'>
      <IoChevronBackCircleOutline style={{color:'red', fontSize:'30px', cursor:'pointer'}}/></Link>}>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={[16, 16]}>
            <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="planname"
                label="Plan Name (Title)"
                rules={[{ required: true, message: 'Please input your Plan Name!' }]} >
                <Input size="large" />
              </Form.Item>
            </Col>
            <Col md={8} sm={12} xs={24}>
            <Form.Item
                name="selectDomain"
                label="Select a Domain"
                rules={[{ required: true, message: 'Please select country!' }]} >
            <Select showSearch placeholder="Select a country" style={{width:'100%'}}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={[
                {
                  value: '1',
                  label: 'Health Care',
                },
                {
                  value: '2',
                  label: 'Movers',
                },
                {
                  value: '3',
                  label: 'Financial Service',
                },
                {
                  value: '4',
                  label: 'Manufacturing',
                },
                {
                  value: '5',
                  label: 'Real Estate',
                },
                {
                  value: '6',
                  label: 'E-Commerce',
                },
                ]}/>
                </Form.Item>
            </Col>
            <Col md={8} sm={12} xs={24}>
            {/* <Form.Item
                name="selectcountry"
                label="Select a country"
                rules={[{ required: true, message: 'Please select country!' }]} >
            <Select showSearch placeholder="Select a country" style={{width:'100%'}}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={[
                {
                  value: '1',
                  label: 'United Kingdom',
                },]}/>
                </Form.Item> */}
            </Col>
            {/* <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="currencycode"
                label="Enter currency code"
                rules={[{ required: true, message: 'Please input your currency code!' }]} >
                <Input size="large" />
              </Form.Item>
            </Col> */}
            <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="planAmountMonthly"
                label="Plan Amount"
                rules={[{ required: true, message: 'Please input your Plan Amount!' }]} >
                <Input type="number" size="large" />
              </Form.Item>
            </Col>
            {/* <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="planAmountYearly"
                label="Plan Amount Yearly"
                rules={[{ required: true, message: 'Please input your Plan Amount!' }]} >
                <Input type="number" size="large" />
              </Form.Item>
            </Col> */}
            <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="taxAmountMonthly"
                label="Plan Tax Amount"
                rules={[{ required: true, message: 'Please input your Tax Amount!' }]}
              >
                <Input type="number" size="large" />
              </Form.Item>
            </Col>
            {/* <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="taxAmountYearly"
                label="Yearly Plan Tax Amount"
                rules={[{ required: true, message: 'Please input your Tax Amount!' }]}
              >
                <Input type="number" size="large" />
              </Form.Item>
            </Col> */}
            <Col md={8} sm={12} xs={24}>
              <Form.Item
                name="leadCount"
                label="Number of Credit"
                rules={[{ required: true, message: 'Please input your lead count!' }]}>
                <Input type="number" size="large" />
              </Form.Item>
            </Col>
            <Col md={12} sm={12} xs={24}>
              <Form.Item name="planList" label="Plan List">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Input
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    type="text"
                    size="large" />
                  <button type="button" className="button-15" onClick={handleAddPlan}>
                    <MdAddCircleOutline size={20} /> ADD PLANS
                  </button>
                </div>
              </Form.Item>
            </Col>
          </Row>
          <div>
          {listItems.map((item, index) => (
            <div key={index} className="list-box" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{item}</span>
              <IoIosCloseCircleOutline
                className="close-icon"
                style={{ cursor: 'pointer' }}
                onClick={() => handleRemove(index)}
              />
            </div>
          ))}
        </div>
          <Form.Item style={{textAlign:'end'}}>
            <Button onClick={handleReset} style={{marginRight:'10px', padding:'18px'}}>Reset input</Button>
          <button className="button-37" style={{ backgroundColor: '#48AF42', color: '#ffff' }} htmlType="submit"
               disabled={loading}>
              Submit
            </button>
          </Form.Item>
        </Form>


      </Card>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscriptionState: state.subscriptionState || {}, // Fallback to empty object  Adjust based on your root reducer
  };
};


const mapDispatchToProps = (dispatch) => ({
  createSubscription: (payload) => dispatch(createSubscriptionRequest(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionMaster);





// import React, { useState, useEffect } from 'react';
// import { IoChevronBackCircleOutline } from "react-icons/io5";
// import { IoIosCloseCircleOutline } from "react-icons/io";
// import { Card, Input, Form, Row, Col, Button, notification } from 'antd';
// import { MdAddCircleOutline } from "react-icons/md";
// import {Link} from 'react-router-dom'
// import { connect } from 'react-redux';
// import {createSubscriptionRequest} from '../store/action/admin/SubscriptionAction';


// const SubscriptionMaster = ({ createSubscription, subscriptionState={} }) => {
//   const [form] = Form.useForm();
//   const [listItems, setListItems] = useState([]); // To store the list of plans
//   const [inputValue, setInputValue] = useState(''); // To track the input value
//   const [isSubmitting, setIsSubmitting] = useState(false); 
//   const { loading = false, response = null, error = null } = subscriptionState;

//   useEffect(() => {
//     console.log('Subscription State Updated:', { response, error }); // Debug state
//     if(isSubmitting){
//       if (response?.message) {
//         notification.success({
//             message: 'Success',
//             description: response.message, // Use the API's success message
//         });
//         form.resetFields();
//         setListItems([]); // Clear the extra plans list
//         setIsSubmitting(false)
//     }
//         if (error) {
//           notification.error({
//             message: 'Error',
//             description: error || 'Something went wrong!',
//           });
//           setIsSubmitting(false); // Reset the flag
//         }
//     }
// }, [response, error,isSubmitting]);



  
//   const handleAddPlan = () => {
//     if (inputValue.trim() !== '') {
//       // Add the input value to the list and reset the input field
//       setListItems([...listItems, inputValue]);
//       setInputValue('');
//     } else {
//       notification.warning({
//         message: 'Validation Error',
//         description: 'Please enter a valid plan name!',
//       });
//     }
//   };

//   const handleRemove = (index) => {
//     const updatedItems = listItems.filter((_, i) => i !== index);
//     setListItems(updatedItems);
//   };
//   const onFinish = (values) => {
//     const textcontent = listItems.reduce((acc, item, index) => {
//         acc[`description${index + 1}`] = item;
//         return acc;
//     }, {});

//     // Create the final payload for the API
//     const payload = {
//         provinceId: 1, 
//         title: values.planname,
//         monthAmount: values.planAmountMonthly,
//         anualAmount: values.planAmountMonthly,
//         taxAmount: values.taxAmountMonthly,
//         creditpoints: values.leadCount,
//         textcontent,
//     };
//     console.log('Payload:', payload);
//     setIsSubmitting(true);
//     // Dispatch the Redux action
//     createSubscription(payload);
// };

// const handleReset = ()=>{
//   form.resetFields();
//   setListItems([]); 
// }


//   return (
//     <div>
//       <Card title="Subscription Master" bordered={false} style={{ width: '100%' }}
//       extra={<Link to='/admin/subscription-master'>
//       <IoChevronBackCircleOutline style={{color:'red', fontSize:'30px', cursor:'pointer'}}/></Link>}>

//         <Form form={form} layout="vertical" onFinish={onFinish}>
//           <Row gutter={[16, 16]}>
//             <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="planname"
//                 label="Plan Name (Title)"
//                 rules={[{ required: true, message: 'Please input your Plan Name!' }]} >
//                 <Input size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="planname"
//                 label="Select contry"
//                 rules={[{ required: true, message: 'Please input your Plan Name!' }]} >
//                 <Input size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="planname"
//                 label="Enter currency code"
//                 rules={[{ required: true, message: 'Please input your Plan Name!' }]} >
//                 <Input size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="planAmountMonthly"
//                 label="Plan Amount Monthly"
//                 rules={[{ required: true, message: 'Please input your Plan Amount!' }]} >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col>
//             {/* <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="planAmountYearly"
//                 label="Plan Amount Yearly"
//                 rules={[{ required: true, message: 'Please input your Plan Amount!' }]} >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col> */}
//             <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="taxAmountMonthly"
//                 label="Monthly Plan Tax Amount"
//                 rules={[{ required: true, message: 'Please input your Tax Amount!' }]}
//               >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col>
//             {/* <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="taxAmountYearly"
//                 label="Yearly Plan Tax Amount"
//                 rules={[{ required: true, message: 'Please input your Tax Amount!' }]}
//               >
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col> */}
//             <Col md={8} sm={12} xs={24}>
//               <Form.Item
//                 name="leadCount"
//                 label="Number of Credit"
//                 rules={[{ required: true, message: 'Please input your lead count!' }]}>
//                 <Input type="number" size="large" />
//               </Form.Item>
//             </Col>
//             <Col md={12} sm={12} xs={24}>
//               <Form.Item name="planList" label="Plan List">
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Input
//                     value={inputValue}
//                     onChange={(e) => setInputValue(e.target.value)}
//                     type="text"
//                     size="large" />
//                   <button type="button" className="button-15" onClick={handleAddPlan}>
//                     <MdAddCircleOutline size={20} /> ADD PLANS
//                   </button>
//                 </div>
//               </Form.Item>
//             </Col>
//           </Row>
//           <div>
//           {listItems.map((item, index) => (
//             <div key={index} className="list-box" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//               <span>{item}</span>
//               <IoIosCloseCircleOutline
//                 className="close-icon"
//                 style={{ cursor: 'pointer' }}
//                 onClick={() => handleRemove(index)}
//               />
//             </div>
//           ))}
//         </div>
//           <Form.Item style={{textAlign:'end'}}>
//             <Button onClick={handleReset} style={{marginRight:'10px', padding:'18px'}}>Reset input</Button>
//           <button className="button-37" style={{ backgroundColor: '#48AF42', color: '#ffff' }} htmlType="submit"
//                disabled={loading}>
//               Submit
//             </button>
//           </Form.Item>
//         </Form>


//       </Card>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   console.log('Redux State:', state);
//   return {
//     subscriptionState: state.subscriptionState || {}, // Fallback to empty object  Adjust based on your root reducer
//   };
// };


// const mapDispatchToProps = (dispatch) => ({
//   createSubscription: (payload) => dispatch(createSubscriptionRequest(payload)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionMaster);





